import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { loadTreatment } from '@surfline/web-common/dist/features/redux';
import RegionalForecast from '../../../../components/RegionalForecast';
import RegionalForecastMeta from '../../../../components/RegionalForecastMeta';
import {
  navigatedToPage,
  trackEvent,
  clickedSubscribeCTA,
} from '../../../../actions/segmentEvents';
import overviewDataPropShape from '../../../../propTypes/subregionOverviewData';
import userDetailsPropType from '../../../../propTypes/userDetails';
import devicePropTypes from '../../../../propTypes/device';
import summaryPropType from '../../../../propTypes/summary';
import {
  getSubregionOverviewData,
  getPrimarySpotId,
  getSubregionAssociated,
} from '../../../../selectors/subregion';
import { getChartDaySummary } from '../../../../selectors/graphs';
import { getUserDetails, getUserEntitlements, getPremiumStatus } from '../../../../selectors/user';
import { subregionForecastAdBaseConfig } from '../../../../utils/adConfig';

class SubregionForecast extends Component {
  componentDidMount() {
    const {
      doNavigatedToPage,
      overviewData: { name, _id },
    } = this.props;
    doNavigatedToPage('Regional Forecast', {
      category: 'forecast',
      channel: 'forecast',
      subregionId: _id,
      subregionName: name,
      viewedLocation: 'regional',
    });
  }

  getSubregionAdConfig = () => {
    const {
      match: {
        params: { subregionId },
      },
      userEntitlements,
      userDetails,
    } = this.props;
    return subregionForecastAdBaseConfig(subregionId, userEntitlements, !!userDetails);
  };

  render() {
    const {
      overviewData,
      primarySpotId,
      isPremium,
      subregionAssociated,
      doTrackEvent,
      doClickedSubscribeCTA,
      doLoadTreatments,
      device,
      summary,
    } = this.props;
    return (
      <div>
        {overviewData ? (
          <div>
            <RegionalForecastMeta
              subregionId={overviewData._id}
              subregionName={overviewData.name}
            />
            <RegionalForecast
              device={device}
              overviewData={overviewData}
              primarySpotId={primarySpotId}
              isPremium={isPremium}
              summary={summary}
              subregionAdConfig={this.getSubregionAdConfig()}
              utcOffset={subregionAssociated.utcOffset}
              abbrTimezone={subregionAssociated.abbrTimezone}
              doTrackEvent={doTrackEvent}
              doClickedSubscribeCTA={doClickedSubscribeCTA}
              doLoadTreatments={doLoadTreatments}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

SubregionForecast.propTypes = {
  overviewData: overviewDataPropShape,
  primarySpotId: PropTypes.string,
  match: PropTypes.shape({
    params: PropTypes.shape({
      subregionId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  userDetails: userDetailsPropType,
  userEntitlements: PropTypes.arrayOf(PropTypes.string),
  isPremium: PropTypes.bool,
  subregionAssociated: PropTypes.shape({
    chartsUrl: PropTypes.string,
    utcOffset: PropTypes.number,
    abbrTimezone: PropTypes.string,
  }).isRequired,
  doTrackEvent: PropTypes.func.isRequired,
  doNavigatedToPage: PropTypes.func.isRequired,
  doClickedSubscribeCTA: PropTypes.func.isRequired,
  doLoadTreatments: PropTypes.func.isRequired,
  summary: summaryPropType.isRequired,
  device: devicePropTypes.isRequired,
};

SubregionForecast.defaultProps = {
  overviewData: null,
  primarySpotId: null,
  userDetails: null,
  userEntitlements: [],
  isPremium: false,
};

export default connect(
  state => ({
    overviewData: getSubregionOverviewData(state),
    primarySpotId: getPrimarySpotId(state),
    userDetails: getUserDetails(state),
    summary: getChartDaySummary(state),
    userEntitlements: getUserEntitlements(state),
    isPremium: getPremiumStatus(state),
    subregionAssociated: getSubregionAssociated(state),
  }),
  dispatch => ({
    doTrackEvent: (event, properties) => dispatch(trackEvent(event, properties)),
    doNavigatedToPage: (name, properties) => dispatch(navigatedToPage(name, properties)),
    doClickedSubscribeCTA: properties => dispatch(clickedSubscribeCTA(properties)),
    doLoadTreatments: treatment => dispatch(loadTreatment(treatment)),
  })
)(withRouter(SubregionForecast));
